import { z } from 'zod'

import type { GraphNode } from './graphTypes'

export const nonBlankTextSchema = z
  .string()
  .refine((value) => value.trim() !== '')
export const dexpiTextSchema = nonBlankTextSchema.optional().catch(undefined)

/* eslint-disable lingui/no-unlocalized-strings -- DEXPI attribute identifiers. */
export const labelFields = [
  'TagName',
  'SubTagName',
  'LineNumber',
  'PipingComponentNumber',
  'PositionNumber',
  'ProcessInstrumentationFunctionNumber',
  'ProcessSignalGeneratingFunctionNumber',
  'MeasuringSystemNumber',
  'ActuatingSystemNumber',
  'ActuatingFunctionNumber',
  'ActuatingElectricalFunctionNumber',
  'InstrumentationLoopFunctionNumber',
] as const
/* eslint-enable lingui/no-unlocalized-strings */

export function getNodeLabel(
  attributes: GraphNode['data']['attributes']
): string | undefined {
  return labelFields
    .map((field) => dexpiTextSchema.parse(attributes[field]))
    .find((label) => label !== undefined)
}
